import React from "react";
import Navbar from "../../components/common/Navbar";
import Banner from "./Banner";
import VerticalLines from "../../components/common/VerticalLines";
import FeatureSection from "./FeaturedSection";
import FunfactSection from "./ChooseSection";
import { Helmet } from 'react-helmet';
import DownloadSection from "./DownloadSection";

const index = () => {
  return (
    <div>
      <Helmet>
        <title>Building Your Future in the Digital Space with CubeX</title>
      </Helmet>
      <Navbar inner={false} />
      <div className="site-content">
        <section className="position-relative">
          <VerticalLines />
          <Banner />
          <FeatureSection />
          <FunfactSection />
          {/* <DownloadSection />  */}
        </section>
      </div>
    </div>
  );
};

export default index;
